var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button"},[_c('a',{staticClass:"link px-9 px-md-5 py-2 mb-2 mb-md-5",class:{disabled:_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-arrow-left"})])])}
var staticRenderFns = []

export { render, staticRenderFns }